import React from 'react';
import dayjs from 'dayjs';
import { OlympicFinishIcon, OlympicGroundIcon } from 'icons';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { globalConst } from 'modules/global';

import { IFinishedTest } from '../models';

interface IProps {
  finishedOlympic?: IFinishedTest;
}

const OlympicCard: React.FC<IProps> = ({ finishedOlympic }) => {
  const t = useTranslations();

  return (
    <div className="h-44.5 relative flex flex-col justify-between overflow-hidden rounded-xl bg-white p-2 sm:p-3">
      <div>
        <Link href={`${globalConst?.pageNames?.ONLINE_OLYMPIC}/olimpiada-${finishedOlympic?.id}`}>
          <p className="text-lg font-medium">{finishedOlympic?.name}</p>
        </Link>
        <div className="mt-2 grid grid-cols-4 items-center gap-2 sm:gap-3">
          <div className="rounded-lg bg-gray-50 px-2 py-2 sm:px-4">
            <div className="flex flex-col">
              <span className="line-clamp-1 text-xs text-gray-400">{t('ishtirokchilar')}</span>
              <span className="text-lg font-bold text-teal-500 sm:text-2xl">
                {finishedOlympic?.total_participants?.toLocaleString('ru') || 0}
              </span>
            </div>
          </div>
          <div className="rounded-lg bg-gray-50 px-2 py-2 sm:px-4">
            <div className="flex flex-col">
              <span className="line-clamp-1 text-xs text-gray-400">{t('variantlar_soni')}</span>
              <span className="text-lg font-bold text-purple-500 sm:text-2xl">{finishedOlympic?.course_count || 0}</span>
            </div>
          </div>
          <div className="rounded-lg bg-gray-50 px-2 py-2 sm:px-4">
            <div className="flex flex-col">
              <span className="line-clamp-1 text-xs text-gray-400">{t('ortacha_natija')}</span>
            <span className="text-lg font-bold text-green-500 sm:text-2xl">{finishedOlympic?.average_percent || 0}%</span>
            </div>
          </div>
          <div className="rounded-lg bg-gray-50 px-2 py-2 sm:px-4">
            <div className="flex flex-col">
              <span className="line-clamp-1 text-xs text-gray-400">{t('maksimal_natija')}</span>
              <span className="text-lg font-bold text-orange-500 sm:text-2xl">{finishedOlympic?.max_percent || 0}%</span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div>
          <div className="z-2 absolute -left-1 bottom-0">
            <OlympicGroundIcon />
          </div>
          <div className="absolute bottom-2.5 z-0">
            <OlympicFinishIcon />
          </div>
          <p className="ml-8 flex items-center gap-1 text-xs text-gray-800">
            <span className="hidden sm:block">{t('ushbu_test_imtihoni')} </span>
            <strong>
              {finishedOlympic?.end_time && dayjs.unix(finishedOlympic?.end_time).format(globalConst.dateFormats.LOCAL_DATE_TIME)}
            </strong>{' '}
            <span className="hidden sm:block">{t('sanada')}</span> {t('yakunlangan')}
          </p>
        </div>
        <Link
          href={`${globalConst?.pageNames?.ONLINE_OLYMPIC}/olimpiada-${finishedOlympic?.id}/natijalar`}
          className="rounded-lg bg-purple-50 px-3 py-1 font-medium text-purple-600 sm:px-4 sm:py-1.5"
        >
          {t('natijani_korish')}
        </Link>
      </div>
    </div>
  );
};

export default OlympicCard;
